import React from 'react'
import { usePlansContext } from '../../../../hooks/usePlansContext'
import { HeaderActionProps } from '../../../../types/headerActionProps'
import { ActionContent } from '../ActionContent'

export const IndividualAction = (props: HeaderActionProps) => {
  const { isIndividualSelected, onClickIndividual } = usePlansContext()

  return (
    <ActionContent
      isSelected={isIndividualSelected}
      onClick={onClickIndividual}
      {...props}
    />
  )
}
